import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec1494ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Il download del report è avvenuta con successo!", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Download del report del dipendente", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, {
    class: "add-new-working-site-modal-dialog",
    type: "modal-alert"
  }, {
    h1: _withCtx(() => [
      _hoisted_1
    ]),
    h3: _withCtx(() => [
      _hoisted_2
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "button bg-primary-900 text-white m-auto text-center",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Torna al menu")
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}